module.exports = __webpack_public_path__ + "static/media/animated_ashutosh.826f4d77.png";